/* Comforts Kids shared helper: window.CK. No DOM work at load, no library. */
(function () {
  'use strict';

  var FALLBACK_FORMAT = 'Rs {{amount_no_decimals}}';
  var NAMED_ENTITIES = { amp: '&', lt: '<', gt: '>', quot: '"', apos: "'", nbsp: ' ' };
  var shopConfig = null;

  /* The admin money format is HTML (for example "&#8360; {{amount}}") and callers write with textContent,
     so turn character references into characters once. Unknown named references stay as typed. */
  function decodeEntities(text) {
    return text.replace(/&(#x[0-9a-f]+|#[0-9]+|[a-z]+);/gi, function (match, ref) {
      if (ref.charAt(0) === '#') {
        var hex = ref.charAt(1) === 'x' || ref.charAt(1) === 'X';
        var code = parseInt(ref.slice(hex ? 2 : 1), hex ? 16 : 10);
        return code > 0 && code <= 0x10ffff ? String.fromCodePoint(code) : match;
      }
      var named = NAMED_ENTITIES[ref.toLowerCase()];
      return named === undefined ? match : named;
    });
  }

  function readShop() {
    if (shopConfig) return shopConfig;
    shopConfig = { moneyFormat: FALLBACK_FORMAT };
    try {
      var el = document.getElementById('ck-shop');
      if (el) {
        var parsed = JSON.parse(el.textContent);
        if (parsed && typeof parsed.moneyFormat === 'string' && parsed.moneyFormat.trim()) {
          shopConfig.moneyFormat = parsed.moneyFormat;
        }
      }
    } catch (e) {
      /* keep fallback */
    }
    shopConfig.moneyFormat = decodeEntities(String(shopConfig.moneyFormat).replace(/<[^>]*>/g, ''));
    return shopConfig;
  }

  function group(intString, sep) {
    return intString.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  }

  /* Every placeholder Shopify allows in a money format (Settings > General > Store currency). */
  var SEPARATORS = {
    amount: [',', '.', 2],
    amount_no_decimals: [',', '', 0],
    amount_with_comma_separator: ['.', ',', 2],
    amount_no_decimals_with_comma_separator: ['.', '', 0],
    amount_with_apostrophe_separator: ["'", '.', 2],
    amount_no_decimals_with_space_separator: [' ', '', 0],
    amount_with_space_separator: [' ', ',', 2],
    amount_with_period_and_space_separator: [' ', '.', 2],
  };

  function formatAmount(cents, kind) {
    var value = Math.round(Number(cents));
    if (!isFinite(value)) value = 0;
    var negative = value < 0;
    value = Math.abs(value);
    var sep = SEPARATORS[kind] || SEPARATORS.amount;
    var out;
    if (sep[2] === 0) {
      out = group(String(Math.round(value / 100)), sep[0]);
    } else {
      var frac = String(value % 100);
      if (frac.length < 2) frac = '0' + frac;
      out = group(String(Math.floor(value / 100)), sep[0]) + sep[1] + frac;
    }
    return (negative ? '-' : '') + out;
  }

  function money(cents) {
    var format = readShop().moneyFormat || FALLBACK_FORMAT;
    /* An unknown placeholder prints the plain amount, never a raw {{...}} */
    return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (match, kind) {
      return formatAmount(cents, kind);
    });
  }

  function waHref(digits, text) {
    var d = String(digits == null ? '' : digits);
    if (!/^[1-9]\d{9,14}$/.test(d)) return null; // country code first: a leading 0 never opens a chat
    return 'https://wa.me/' + d + '?text=' + encodeURIComponent(String(text == null ? '' : text));
  }

  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  /* Hero and sticky Order now forward to the buy box form, which is usually off screen. When it cannot
     order (error, sold out, busy re-render), bring the buy box into view and move focus to the reason. */
  function revealOrderIssue(button) {
    if (!button || !button.closest) return;
    var form = button.closest('product-form');
    var root = button.closest('product-info') || form;
    if (!root) return;
    var reason = null;
    var error = form && form.querySelector('.product-form__error-message-wrapper');
    if (error && !error.hidden) reason = error;
    if (!reason) {
      var sold = root.querySelector('[data-ck-soldout]');
      if (sold && sold.textContent.trim()) reason = sold;
    }
    var target = reason || button.closest('.product-form__buttons') || root;
    target.scrollIntoView({ block: 'center', behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
    if (reason) {
      if (!reason.hasAttribute('tabindex')) reason.setAttribute('tabindex', '-1');
      reason.focus({ preventScroll: true });
    }
  }

  function subscribeGuarded(key, fn) {
    var noop = function () {};
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS[key]) {
        return subscribe(PUB_SUB_EVENTS[key], fn) || noop;
      }
    } catch (e) {
      /* fall through */
    }
    return noop;
  }

  window.CK = {
    money: money,
    waHref: waHref,
    onVariantChange: function (fn) {
      return subscribeGuarded('variantChange', fn);
    },
    onCartUpdate: function (fn) {
      return subscribeGuarded('cartUpdate', fn);
    },
    prefersReducedMotion: prefersReducedMotion,
    revealOrderIssue: revealOrderIssue,
  };
})();
